<template>
  <div>
    <el-table  height="226.5px" stripe :header-cell-style="getCellClass" row-key="d_id" ref="multipleTable"
               :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
               @sort-change="sortChange" :data="tableData">
      <el-table-column prop="title" label="标题" min-width="160" fixed="left" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new"  @click="showDialogVisible('createWorkOrder', scope.row)">【{{scope.row.id}}】{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="80"  fixed="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="module_code" label="系统" width="80"  fixed="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="state" label="状态" width="80"  fixed="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="remind_count" label="催单次数" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_text_click_new" style="text-decoration:none;"  @click="showDialogVisible('reminderDetail', scope.row)">{{scope.row.remind_count}}次</span>
        </template>
      </el-table-column>
      <el-table-column prop="submitter_id" label="提出人" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.submitter_id ? scope.row.submitter_id.nameZh : ''}} {{scope.row.submitter_id.nameEn ? '(' +scope.row.submitter_id.nameEn + ')' : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="dept" label="提出部门" width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="create_time" label="提出时间" width="80" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <CreateWorkOrder v-if="dialogVisible.createWorkOrder" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.createWorkOrder'
                     :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></CreateWorkOrder>
    <ReminderDetail v-if="dialogVisible.reminderDetail" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.reminderDetail'
                    :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></ReminderDetail>
  </div>
</template>
<script>
import CreateWorkOrder from "@/views/tops/devOps/workOrder/components/createWorkOrder.vue";
import ReminderDetail from "@/views/tops/devOps/workOrder/components/reminderDetail.vue";
export default {
  components: {CreateWorkOrder, ReminderDetail},
  props: {
    tableData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 弹出层部分
      dialogVisible: {
        demand: false,
        task: false,
        toDevelop: false,
        developing: false,
        toTest: false,
        testEnvTesting: false,
        preEnvTesting: false,
        uatTesting: false,
        toRelease: false,
        proEnvTesting: false,
        online: false,
        addBug: false,
        project: false,
        report: false,
        record: false,
        createWorkOrder: false,
        reminderDetail: false,
      },
      // 选中信息
      checkedInfo: {},
      back : '',
    }
  },
  async mounted() {
  },
  created() {
  },
  methods:{
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;font-size:12px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let newRow = {...row};
      if(type === 'task'){
        if(!row.taskId){
          newRow = {...row,taskId:row.id}
        }else{
          newRow = {...row,taskId:row.taskId}
        }
      }
      if(type === 'project'){
        newRow = {name : row.projectName, id: row.projectId}
      }
      if(type === 'demand'){
        newRow = {name : row.demandName, id: row.demandId}
      }
      if (type === 'releaseing') {
        return;
      }
      //  await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let pid = '';
      if(nextStep === 'demand'){
        pid = this.checkedInfo.id;
      }

      if (nextStep && (typeof(nextStep) === 'string')) {
        /*const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : { task_title: this.checkedInfo?.taskInfo?.id }
        const ret = await postDevOpsSpaceDevTaskApi(params);
        const tableData = this.formatTableData(ret.data) || [];
        this.checkedInfo = tableData[0];
        this.checkedInfo.next = (nextStep === 'demand')
        if(nextStep === 'demand'){
          this.checkedInfo = {id:pid};
        }*/
        this.$nextTick(() => {
          this.dialogVisible[nextStep] = true;
        })
      } else {
        // search && await this.formSearch()
      }
      this.$emit('changeTask');
    },
  },
}
</script>
